import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { hasUserRoutePermission, isPlatformPlanPaymentsPath } from '../config/permissions';
import { usePlatformBilling } from '../hooks/usePlatformBilling';
import AuthLoadingScreen from './AuthLoadingScreen';
import BillingBlockedScreen from './BillingBlockedScreen';

interface ProtectedRouteProps {
  children: React.ReactNode;
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children }) => {
  const { isAuthenticated, isLoading, user, defaultRoute } = useAuth();
  const location = useLocation();
  const billing = usePlatformBilling();

  // Mostrar loading enquanto verifica
  if (isLoading) {
    return <AuthLoadingScreen variant="light" />;
  }

  // Se não estiver autenticado, redirecionar para login
  if (!isAuthenticated || !user) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  // Permissões: admin/admin_master tratados em hasRoutePermission (trechos só master)
  if (!hasUserRoutePermission(user, location.pathname)) {
    return <Navigate to={defaultRoute} replace />;
  }

  // Mensalidade da plataforma com a carência estourada: o sistema fica restrito
  // à tela de pagamento, que segue acessível para o Admin Master regularizar.
  if (billing.blocked && !isPlatformPlanPaymentsPath(location.pathname)) {
    return <BillingBlockedScreen state={billing} />;
  }

  // Se estiver autenticado e com permissão, mostrar o conteúdo
  return <>{children}</>;
};

export default ProtectedRoute;
